import React from 'react';
import SynapseWebServiceSettings from './../settings/AlexaWebService.json';
import Dropdown from './../assets/ui_assets/controls/Dropdown';
import { LocalizationContext } from 'localization-context';
import { AlexaCommon } from 'utils/Common'
const autoBind = require('auto-bind');


class RZLanguagePanel extends React.Component {

    constructor(props) {
        super(props);
        autoBind(this);
    }

    populateOption(languageData) {
        let optionList = [];
        if (!languageData) { return optionList; }

        let languageDataList = languageData.supported;
        if (!languageDataList) { return; }
        optionList = languageDataList.map((item, index) => {
            return { content: SynapseWebServiceSettings[item], name: SynapseWebServiceSettings[item], languageId: item }
        });
        AlexaCommon.sortLanguageList(optionList);
        //handle empty optionList
        if (optionList.length === 0){
            optionList = [...optionList, {content: "",name:""}];
        }
        return optionList;
    }

    onOptionChange(index) {
        let languageId = this.getLanguageIdFromOptionListItemContent(index);
        if (typeof this.props.handleOnLanguageChange === "function"
            && typeof languageId !== "undefined") {
            this.props.handleOnLanguageChange(languageId);
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (typeof nextProps.languageData === "undefined") {
            return false;
        }
        if (typeof nextProps.languageData.active === "undefined") {
            return false;
        }
        return true;
    }

    getLanguageIdIndexOfOptionsList() {
        if (this.props.languageData) {
            let optionsList = this.populateOption(this.props.languageData);
            let targetOptionIndex = optionsList.findIndex((item) => {
                return AlexaCommon.getLowerCase(item.languageId) === AlexaCommon.getLowerCase(this.props.languageData.active);
            });
            return targetOptionIndex;
        }
    }

    getLanguageIdFromOptionListItemContent(index) {
        if (typeof index === "undefined") { return; }
        let optionsList = this.populateOption(this.props.languageData);
        let targetOption = optionsList[index]
        if (targetOption) {
            return targetOption.languageId;
        }
    }

    renderDropDownElement() {
        let dropdown = "";
        if (this.props.languageData) {
            let dropDownIndex = this.getLanguageIdIndexOfOptionsList();
            let optionList = this.populateOption(this.props.languageData);
            dropdown = <Dropdown
                dataSet={optionList}
                name="languageList"
                selectOption={this.onOptionChange}
                value={dropDownIndex}
            />
        }
        return dropdown;
    }
    render() {

        let dropdown = this.renderDropDownElement();
        let isPanelDisabledClassName = typeof this.props.alexaStatus !== "undefined" ? (this.props.alexaStatus ? "alexa-not-disabled":"alexa-disabled") : "alexa-not-disabled";
        return (
            <LocalizationContext.Consumer>
                {values => (
                    <div className={`settings-container-1 ${isPanelDisabledClassName}`} style={{paddingTop:'10px'}}>
                        <div className="settings-wrapper-1">
                            <div className="settings-title alexa-none">
                                <span>{values.language}</span>
                            </div>
                            <div className="settings-language">
                                <div className="settings-subtitle settings-subcontent" style={{textTransform: 'uppercase'}}>
                                    {values.language}
                                </div>
                                <div className="settings-language-selection settings-subcontent">
                                    {dropdown}
                                </div>
                            </div>
                        </div>
                        {/* <div className="widget rztooltip">
                            <div className="help" />
                            <div className="tip">
                                {values.toolTipsTest}
                            </div>
                        </div> */}
                    </div>
                )}
            </LocalizationContext.Consumer>
        );
    }
}
export default RZLanguagePanel;
